import { render } from "./NavBlock.vue?vue&type=template&id=01b9ce03&scoped=true"
const script = {}

import "./NavBlock.vue?vue&type=style&index=0&id=01b9ce03&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b9ce03"]])

export default __exports__